export default __webpack_public_path__ + "static/media/gerjan.fcdc32f6.png";